<template>
    <main>
        <hero />

        <intro />

        <story-slider style="margin-top: -13.5rem;" />

        <ow-footer />
    </main>
</template>

<script>
import Hero from '@/components/home/Hero';
import Intro from '@/components/home/Intro';
import OwFooter from '@/components/common/OwFooter';
import StorySlider from '@/components/home/storySlider/Index';

export default {
    name: 'Home',
    components: { 
        Hero,
        Intro,
        OwFooter,
        StorySlider,
    },
};
</script>
